<template>
  <div id="app">
    <router-view v-if="!$route.meta.keepAlive"></router-view>
    <keep-alive>
      <router-view v-if="$route.meta.keepAlive"></router-view>
    </keep-alive>
    <EtmsBackTop />
  </div>
</template>

<script>
export default {
  name: "App",
};
</script>

<style>
#app {
  color: #323233;
}
</style>



// WEBPACK FOOTER //
// src/App.vue